/**
 * USA timezones only, with display names and UTC offset formatting.
 */

export const USA_TIMEZONES = [
  { id: 'America/New_York', name: 'Eastern Time' },
  { id: 'America/Chicago', name: 'Central Time' },
  { id: 'America/Denver', name: 'Mountain Time' },
  { id: 'America/Phoenix', name: 'Arizona' },
  { id: 'America/Los_Angeles', name: 'Pacific Time' },
  { id: 'America/Anchorage', name: 'Alaska Time' },
  { id: 'Pacific/Honolulu', name: 'Hawaii Time' },
];

/**
 * Get UTC offset string for a timezone (e.g. "UTC-05:00" or "UTC+10:00").
 * Uses current date so DST is respected.
 */
export function getTimezoneOffsetString(tzId) {
  try {
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: tzId,
      timeZoneName: 'longOffset',
    });
    const parts = formatter.formatToParts(new Date());
    const tzPart = parts.find((p) => p.type === 'timeZoneName');
    if (tzPart && tzPart.value) {
      let s = tzPart.value.replace('GMT', 'UTC');
      // Normalize to UTC±HH:MM (e.g. UTC-5 -> UTC-05:00)
      const match = s.match(/^(UTC)([+-])(\d{1,2})(?::(\d{2}))?$/);
      if (match) {
        const [, prefix, sign, h, m] = match;
        const hh = h.padStart(2, '0');
        const mm = (m || '00').padStart(2, '0');
        s = `${prefix}${sign}${hh}:${mm}`;
      }
      return s;
    }
  } catch (_) {}
  return '';
}

/**
 * Full display label for a timezone id, e.g. "Eastern Time (UTC-05:00)".
 */
export function getTimezoneDisplayLabel(tzId) {
  if (!tzId) return '';
  const tz = USA_TIMEZONES.find((z) => z.id === tzId);
  const name = tz ? tz.name : tzId.replace(/_/g, ' ');
  const offset = getTimezoneOffsetString(tzId);
  return offset ? `${name} (${offset})` : name;
}

/**
 * Default timezone: user's if it's a USA zone we support, otherwise Eastern.
 */
export function getDefaultTimezone() {
  try {
    const resolved = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    if (USA_TIMEZONES.some((z) => z.id === resolved)) return resolved;
  } catch (_) {}
  return 'America/New_York';
}
